import { UserDto } from '../dtos/user';
import { User } from '../models/user';

export const dtoToUser = (user: UserDto): User => {
  const { name, careem_user_id, city, email, phone } = user;
  return {
    name,
    userId: careem_user_id,
    city,
    email,
    phone
  };
};
